"use client"

import { Component } from "react"
import ErrorDisplay from "./ErrorDisplay"

class ErrorBoundary extends Component {
  state = { error: null }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error("Page crashed:", error, info.componentStack)
  }

  handleRetry = () => {
    this.setState({ error: null })
  }

  render() {
    if (!this.state.error) {
      return this.props.children
    }

    return (
      <ErrorDisplay
        title="This page hit a problem"
        message="Something went wrong while showing this page. Your other pages and your data are not affected."
        onRetry={this.handleRetry}
        retryLabel="Try again"
      />
    )
  }
}

export default ErrorBoundary
